<template>
  <div>
    <Transition name="fade">
      <SignIn v-if="!forget" @switchForget="switchForget" />
      <RecoverPassword v-if="forget" @switchForget="switchForget" />
    </Transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import * as firebase from "firebase/app";
// import "firebase/auth";

// Views
import SignIn from "./Auth/SignIn.vue";
import RecoverPassword from "./Auth/RecoverPassword.vue";

export default {
  data() {
    return {
      user: {},
      email: "",
      forget: false,
      tokenUserC: {},
      validRoles: [
        "admin",
        "cliente",
        "liderl",
        "lider",
        "frs",
        "ghumana",
        "free",
      ],
    };
  },
  computed: {
    ...mapState(["isAuthenticated"]),
  },
  methods: {
    switchForget() {
      this.forget = !this.forget;
    },
  },
  watch: {
    isAuthenticated(newv, oldv) {
      if (newv) {
        this.$router.push("home");
      }
    },
  },
  components: {
    SignIn: SignIn,
    RecoverPassword: RecoverPassword,
  },
};
</script>

<style lang="scss">
.container-login {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-color: #f7f7f7;
}

.container-login .background {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0.9;
  background-image: url("~@/assets/bg-login.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.container-login .form-container {
  width: 100%;
  max-width: 28rem;
  z-index: 10;
}

.container-login .form {
  background-color: white;
  border-radius: 1rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.container-login .icon-container {
  display: flex;
  justify-content: center;
}

.container-login .logo {
  width: 17rem;
  height: 6rem;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container-login .text-container {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.text-container h1 {
  font-size: 1.5rem;
  font-weight: 900;
  color: #1f2937;
}

.text-container p {
  color: #6b7280;
}

.container-login .form-fields {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.container-login .input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.input-group label {
  font-size: 0.875rem;
  font-weight: 500;
}

.input-group .text-muted {
  font-size: 0.8rem;
  color: #9aa0ac;
}

.text-muted:hover {
  color: #522687;
}

.input-group input {
  height: 2.5rem;
  border-radius: 0.375rem;
  border: 1px solid #d1d5db;
  background-color: #f7f7f7;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  width: 100%;
}

.input-group input:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px #a78bfa, 0 0 0 4px rgba(0, 0, 0, 0.1);
}

.container-login .submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  height: 2.5rem;
  padding: 0.5rem 1rem;
  width: 100%;
  cursor: pointer;
  border: 2px solid #e5e7eb;
  background-color: #522687;
  color: #ffffff;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  border: 2px solid #9d4edd;
  background-color: rgba(#9d4edd, 0.9);
}

.container-login .divider {
  text-align: center;
  position: relative;
}

.divider .line {
  position: absolute;
  top: 50%;
  width: 100%;
  border-top: 1px solid #e5e7eb;
}

.divider span {
  position: relative;
  display: inline-flex;
  justify-content: center;
  font-size: 0.875rem;
  background-color: white;
  color: #6b7280;
  padding: 0 0.5rem;
}

.container-login .google-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border: 2px solid #e5e7eb;
  background-color: #f7f7f7;
  height: 2.5rem;
  padding: 0.5rem 1rem;
  width: 100%;
  transition: background-color 0.3s, color 0.3s;
}

.google-btn:hover {
  border: 2px solid #9d4edd;
  background-color: #9d4edd;
  color: #ffffff;
}

.container-login .google-icon {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/core/Login.vue